import type { StrictOmit } from "ts-essentials";
import type { ResourceFieldsProps } from "~/components/DetailsCards";
import { ResourceFields } from "~/components/DetailsCards";
import { renderForeignResource } from "./renderForeignResource";
import type { DsmForeignResourceType } from "./types";

type DsmResourceFieldsProps<TResource extends object> = StrictOmit<
  ResourceFieldsProps<TResource, DsmForeignResourceType>,
  "renderForeignResource"
>;

export function DsmResourceFields<TResource extends object>(
  props: DsmResourceFieldsProps<TResource>,
) {
  return (
    <ResourceFields {...props} renderForeignResource={renderForeignResource} />
  );
}
